import React, { useState, useEffect } from 'react';
import Modal from '../Modal';

const ReasonModal = ({ isOpen, onClose, onSubmit, title, description, submitLabel = "Submit" }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setReason("");
      setError("");
    }
  }, [isOpen]);

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError("Reason is required");
      return;
    }
    onSubmit(reason);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <div className="space-y-4">
        {description && (
          <p className="text-gray-600 text-sm">{description}</p>
        )}
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Write Reason <span className="text-red-500">*</span>
          </label>
          <textarea
            className={`w-full border rounded-lg p-3 text-sm focus:ring-2 focus:ring-blue-500 outline-none ${
              error ? "border-red-500 bg-red-50" : "border-gray-300"
            }`}
            rows="4"
            placeholder="Type your reason here..."
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              if (error) setError("");
            }}
          />
          {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
        </div>

        <div className="flex justify-end gap-3 pt-2">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 text-sm font-medium transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium shadow-sm transition-colors"
          >
            {submitLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ReasonModal;
